'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const FranchiseCategorySelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required
}) => {
  const { fetchFranchiseCategories, franchiseCategories } = useLookupsStore()
  const [options, setOptions] = useState(testData || franchiseCategories || [])

  useEffect(() => {
    if (testData) return
    setOptions(franchiseCategories || [])
  }, [testData, franchiseCategories])

  useEffect(() => {
    if (testData || franchiseCategories?.length) return
    fetchFranchiseCategories()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, franchiseCategories])

  return (
    <div data-testid="FranchiseCategorySelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Franchise category"
        onChange={onChange}
        labelKey="description"
        valueKey="franchiseId"
        items={options}
        value={value}
        searchable
        idLabelKey="franchiseId"
        showIdInResults={false}
        name="franchiseCategory"
        size={size}
        required={required}
      />
    </div>
  )
}

FranchiseCategorySelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool
}
